import React from 'react'
import './terms-section.scss'

import useCallModal from '../../../utils/callModal'
const TermsSection = () => {
  const [callModal] = useCallModal()
  const openTermsModal = () => {
    callModal('terms', {}, { className: 'not-card' })
  }
  return (
    <section className="f-terms-section">
      <b>
        {' '}
        <a
          className="f-terms-section__aTerminos"
          rel="noopener noreferrer"
          tag="7A"
          onClick={evt => {
            openTermsModal()
          }}
        >
          Términos y condiciones del juego
        </a>
      </b>
    </section>
  )
}

export default TermsSection
